import { DndContext, KeyboardSensor, PointerSensor, TouchSensor, closestCenter, useSensor, useSensors } from "@dnd-kit/core";
import { SortableContext, arrayMove, rectSortingStrategy, sortableKeyboardCoordinates, useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { WallCard } from "@/components/wallboard/WallCard";

const SortableCard = ({ it, rank }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: it.key });
  const style = { transform: CSS.Transform.toString(transform), transition, zIndex: isDragging ? 50 : undefined };
  return <WallCard ref={setNodeRef} it={it} rank={rank} ordering dragging={isDragging} style={style} handleProps={{ ...attributes, ...listeners }} />;
};

export const WallGrid = ({ items, ordering, onReorder, onOpen }) => {
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 5 } }),
    useSensor(TouchSensor, { activationConstraint: { delay: 120, tolerance: 6 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates }),
  );
  const grid = { display: "grid", gap: "1em", gridTemplateColumns: "repeat(auto-fill, minmax(19em, 1fr))" };

  if (!ordering) {
    return <div style={grid} data-testid="wallboard-grid">{items.map((it, i) => <WallCard key={it.key} it={it} rank={i + 1} onOpen={onOpen} />)}</div>;
  }

  const onDragEnd = ({ active, over }) => {
    if (!over || active.id === over.id) return;
    const from = items.findIndex((i) => i.key === active.id);
    const to = items.findIndex((i) => i.key === over.id);
    onReorder(arrayMove(items, from, to));
  };

  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={onDragEnd}>
      <SortableContext items={items.map((i) => i.key)} strategy={rectSortingStrategy}>
        <div style={grid} data-testid="wallboard-grid-ordering">
          {items.map((it, i) => <SortableCard key={it.key} it={it} rank={i + 1} />)}
        </div>
      </SortableContext>
    </DndContext>
  );
};
